import { memo } from "react";

export const ConfirmedIcon = memo(function ConfirmedIcon({
  className,
}: {
  className: string;
}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M17.2222 19.9998V18.2221C17.2222 17.2791 16.8476 16.3747 16.1808 15.7079C15.514 15.0411 14.6096 14.6665 13.6667 14.6665H6.55555C5.61256 14.6665 4.70819 15.0411 4.0414 15.7079C3.3746 16.3747 3 17.2791 3 18.2221V19.9998"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1112 11.1111C12.0749 11.1111 13.6668 9.51923 13.6668 7.55555C13.6668 5.59187 12.0749 4 10.1112 4C8.14754 4 6.55566 5.59187 6.55566 7.55555C6.55566 9.51923 8.14754 11.1111 10.1112 11.1111Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.1758 6.29909C23.5848 6.69816 23.5851 7.34555 23.1766 7.74501L19.4124 11.3059C19.2161 11.4978 18.9498 11.6056 18.6721 11.6057C18.3944 11.6058 18.1281 11.498 17.9317 11.3062L16.3066 9.745C15.8978 9.34573 15.8978 8.69834 16.3066 8.29907C16.7154 7.89981 17.3781 7.89981 17.7869 8.29907L18.6715 9.13698L21.6955 6.29981C22.1041 5.90035 22.7669 5.90002 23.1758 6.29909Z"
        fill="current"
      />
    </svg>
  );
});
